import React from "react";
import { CompanyMahnungswesenInformation } from "@/dentlab/src/forms/form-components/company-mahnungswesen-information.component";

export const MahnungswesenPage: React.FC = () => {
	return (
		<div className="p-6">
			<div className="max-w-6xl">
				<h1 className="text-2xl font-semibold text-gray-900 mb-6">Mahnungswesen</h1>
				<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
					<CompanyMahnungswesenInformation />
				</div>
			</div>
		</div>
	);
};